import React from 'react';
import contestAwardPropType from '../../propTypes/contestAward';

const ContestAwardCard = ({ award }) => (
  <div className="sl-contest-award">
    <img className="sl-contest-award__image" src={award.imageUrl} alt={award.title} />
    <div className="sl-contest-award__content">
      <h6 className="sl-contest-award__title">{award.title}</h6>
      <p className="sl-contest-award__description">{award.description}</p>
    </div>
  </div>
);

ContestAwardCard.propTypes = {
  award: contestAwardPropType.isRequired,
};

export default ContestAwardCard;
